export const MAP_STYLE_URL = `${process.env.NEXT_PUBLIC_APP_ORIGIN}/api/map-style`
